import BasicButton from "../../../components/BasicButton";
import { colors } from "../../../data/colors";
import { useTranslation } from "react-i18next";
import { useStructureContext } from "../../../context/StructureContext";
import { filterSubsections } from "../../../utils/filterSubsections";
import { useMainContext } from "../../../context/MainContext";

export default function MainMenu({
  extraSection = [],
}: {
  extraSection?: Array<{ id: string; code: string; value: number }>;
}) {
  const { t } = useTranslation();
  const { selectMode, returnToDoc } = useMainContext();
  const { subSections, updateSection, type, section } = useStructureContext();
  const writeLabel = (e: string) => {
    switch (e) {
      case "G1":
        return t("c.B1");
      case "G2":
        return t("c.B2");
      case "G3":
        return t("c.CLI2");
      default:
        return t(`c.${e}`);
    }
  };
  return (
    <div style={{ overflow: "auto" }}>
      <table align="center">
        <tbody>
          <tr>
            {selectMode.active ? (
              <td align="center">
                <div style={{ fontSize: 14, fontWeight: "bolder", padding: 5 }}>
                  {selectMode.serviceStep === 3
                    ? t("p.selectWhoToBill")
                    : selectMode.serviceStep === 2
                      ? t("p.selectACustomer", {
                          aCustomer: t("p.aCustomer").toLowerCase(),
                        })
                      : section.id === "ART"
                        ? t("p.selectAnItem", {
                            anItem: t("p.anItem").toLowerCase(),
                          })
                        : section.id === "PRO"
                          ? t("p.selectASupplier", {
                              aSupplier: t("p.aSupplier").toLowerCase(),
                            })
                          : t("p.selectACustomer", {
                              aCustomer: t("p.aCustomer").toLowerCase(),
                            })}
                </div>
                <BasicButton
                  title={t("p.cancel")}
                  // color={colors[type]}
                  onClick={() => returnToDoc()}
                />
              </td>
            ) : (
              <>
                {filterSubsections(subSections).map((e, index) => (
                  <td key={index}>
                    <BasicButton
                      title={writeLabel(e)}
                      color={colors[type]}
                      onClick={() => updateSection({ key: e })}
                      style={{ opacity: section.id === e ? 1 : 0.5 }}
                    />
                  </td>
                ))}
                {extraSection
                  .filter((e) => e.value > 0)
                  .map((e, index) => (
                    <td key={index}>
                      <BasicButton
                        title={t(`c.${e.code}`)}
                        color={colors[type]}
                        onClick={() => updateSection({ key: e.id })}
                        style={{ opacity: section.id === e.id ? 1 : 0.5 }}
                      />
                    </td>
                  ))}
              </>
            )}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
